import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import PromosContent from "@Types/promos";
import "./style.scss";

interface Props {
  onClickPromo: (code: string) => void;
  promo: PromosContent;
}

const CartPromoCodesListItem: FunctionComponent<Props> = ({ onClickPromo, promo }) => {
  const intl = useIntl();

  return (
    <div className="CartPromoCodesListItem" onClick={() => onClickPromo(promo.code)}>
      <div className="CartPromoCodesListItem-title">{promo.title}</div>
      <div className="CartPromoCodesListItem-description">{promo.description}</div>
      <ButtonSmily onClick={() => onClickPromo(promo.code)} size="s" type="secondary">
        {intl.formatMessage({ id: "cheerz_CartPromoCodesListItem_apply" }, { code: promo.code })}
      </ButtonSmily>
    </div>
  );
};

export default CartPromoCodesListItem;
